/**
 * Return keyboardType passed as function parameter on Web/Desktop/iOS
 * @param {String} keyboardType
 * @return {String}
 */
export default keyboardType => keyboardType;
